export enum RBErrorCode {
    'STORAGE_NOT_ENOUGH_SPACE_AVAILABLE' = 600001,
    'TODO_MAX_CATEGORY_REACHED' = 600002
}

export class RBError extends Error {

    public errorCode?: RBErrorCode;
    public details: any;
    public detailsCode?: any;
    public detailsData?: any;

    public static create(message: string, errorCode?: RBErrorCode): RBError {
        const error = new RBError(message);
        error.errorCode = errorCode;
        return error;
    }

    constructor(message: string, details = null, detailsCode = null, detailsData = null) {
        super();
        this.name = "RainbowError";
        this.message = message;
        this.details = details;
        this.detailsCode = detailsCode;
        this.detailsData = detailsData;
    }
}
